import { cn } from '@/components/ui/cn';

export interface TopoBackgroundProps {
  /** Opacity 0–1. Default 0.06 — the Quiet Atlas spec value. */
  opacity?: number;
  /** Extra classes — usually positioning ('absolute inset-0', 'fixed inset-0'). */
  className?: string;
}

/**
 * Topographic contour-line motif drawn from `/topo-pattern.svg`.
 *
 * Decorative only — always rendered with `aria-hidden` and `pointer-events-none`.
 * Default opacity sits at 6% to match the Quiet Atlas direction spec.
 */
export function TopoBackground({ opacity = 0.06, className }: TopoBackgroundProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none bg-[url("/topo-pattern.svg")] bg-repeat',
        className,
      )}
      style={{ opacity }}
    />
  );
}
